export const menuTypes = {
  menu: "menu",
  takeaway: 'takeaway',
  marketplace: 'marketplace',
}

export const orderStatus = (status) => {
  const statuses = {
    [-1]: 'order-statuses.error',
    0: 'order-statuses.unpaid',
    1: 'order-statuses.created',
    2: 'order-statuses.accepted',
    3: 'order-statuses.pending',
    4: 'order-statuses.cooking',
    5: 'order-statuses.ready',
    6: 'order-statuses.on_the_way',
    7: 'order-statuses.delivered',
    8: 'order-statuses.canceled',
    9: 'order-statuses.deleted'
  };

  return statuses[status] ?? '';
};


export const YANDEX_MAP_KEY = 'bfec55fc-9bdb-437e-8d05-968234d3b807';
/*'4b9f0317-819e-476e-bbfc-423894cb7bd5'*/
/*'1e89d5c1-1078-4076-81f1-560f3fa856b2'*/